import { EquipmentFormValue } from "../types";
import { Equipment } from "../api/equipment/types";
import { formatStringToNumber } from "../../../utils/formatters";

export function mapEquipmentEntityToFormValue(equipment: Equipment): EquipmentFormValue {
  return {
    commonInfo: {
      year: equipment.year,
      make: equipment.make,
      model: equipment.model,
      class: equipment.classType,
      stockId: equipment.stockId,
      mileage: equipment.mileage,
      quality: equipment.quantity,
      condition: equipment.newUsed,
      vin: equipment.serialNumberVin,
      saleCost: equipment.wholesaleCost,
      retailPrice: equipment.retailPrice,
      wholeSaleCost: equipment.wholesaleCost,
      description: equipment.additionalDescription,
    },
    attachments:
      equipment?.attachments?.map(attachment => ({
        ...attachment,
        unitCost: formatStringToNumber(attachment.unitCost) ?? 0,
      })) ?? [],
  };
}
